// Static routes to run the app. Only use one: local or heroku.
//export const API_ENDPOINT = 'http://localhost:8080/api/';
export const API_ENDPOINT = 'https://typhinet.herokuapp.com/api/';
